import { render, staticRenderFns } from "./VodacomMzTransactionDetail.vue?vue&type=template&id=358013da&scoped=true"
import script from "./VodacomMzTransactionDetail.vue?vue&type=script&lang=js"
export * from "./VodacomMzTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./VodacomMzTransactionDetail.vue?vue&type=style&index=0&id=358013da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358013da",
  null
  
)

export default component.exports